import { format, subMonths } from "date-fns";
import React from "react"
import { useEffect } from "react"
import { useQuery } from "react-query";
import { formatMoney, occurrencesOf, toFullName, toStartCase } from "utils/functions"
import makeData from "utils/makeData"
import useReports from "./useReports";


const useDonationReport = () => {
  const [search, setSearch] = React.useState('');
  const [level, setSearchLevel] = React.useState('');
  const [status, setSearchStatus] = React.useState('');
  const [cycle, setSearchCycle] = React.useState('');
  const [page, setPage] = React.useState(1)
  const [dateJoinedFrom, setDateJoinedFrom] = React.useState('');
  const [dateJoinedTo, setDateJoinedTo] = React.useState('');
  const [donationDateFrom, setDonationDateFrom] = React.useState('');
  const [donationDateTo, setDonationDateTo] = React.useState('');
  const { getDonationReport } = useReports()


  const { data, isLoading } = useQuery(['donations', level, status, cycle, dateJoinedFrom, dateJoinedTo, donationDateFrom, donationDateTo], () => getDonationReport(page, search, level, status, cycle, dateJoinedFrom, dateJoinedTo, donationDateFrom, donationDateTo), {
    select: data => data.data.donation_report
  })

  const dataReport = useQuery(['donors', page, search, level, status, cycle, dateJoinedFrom, dateJoinedTo, donationDateFrom, donationDateTo, 'report'], () => getDonationReport(page, search, level, status, cycle, dateJoinedFrom, dateJoinedTo, donationDateFrom, donationDateTo), {
    onSuccess: (res) => {
      // setDonors(res.data.users.data)
      const permOpt = res.data.donation_report.map(item => {
        return { id: item.id, value: item.id, email: item.email, phone: item.phone_mobile, label: toFullName({ firstName: item.first_name, lastName: item.last_name }) }
      })
      setData(res.data.donation_report)
    },
    onError: err => {
      console.log(err)
      // notify('post creation failed!', { type: 'error' })
    },
    staleTime: Infinity,
    cacheTime: Infinity
  })

  const [, setData] = React.useState(React.useMemo(() => makeData('aausers', 100), []))
  const [currentData, setCurrentData] = React.useState(null)
  const [current, setCurrent] = React.useState('')
  const [open, setOpen] = React.useState(false)
  const [edit, setEdit] = React.useState(false)
  const [pagesize, setPageSize] = React.useState(100)
  const [selectedYear, setSelectedYear] = React.useState(new Date().getFullYear())
  const [bar_data, setBar_data] = React.useState([])
  const [line_data, setLine_data] = React.useState([])
  const [line2_data, setLine2_data] = React.useState([])
  const [pie_data, setPie_data] = React.useState([])
  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const updateMyData = () => {
    // We also turn on the flag to not reset the page
    setSkipPageReset(true)
    // setData logic was here but was using the wrong state
  }

  const dummy_data = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: [
      {
        label: `donations(NGN) - ${selectedYear}`,
        backgroundColor: "rgba(2,117,216,1)",
        borderColor: "rgba(2,117,216,1)",
        data: Array.from({ length: 12 }, (_, i) => {
          const monthData = bar_data.find(item => new Date(item.date).getMonth() === i)
          return monthData ? monthData.amount : 0
        }),
      },
    ],
  };


  const dummy_line2_data = {
    labels: line2_data.length ? line2_data.map(item => format(new Date(item.date), 'MMM dd')) : [],
    datasets: [
      {
        fill: true,
        label: "Total Amount(NGN)",
        lineTension: 0.3,
        backgroundColor: "rgba(2,117,216,0.2)",
        borderColor: "rgba(2,117,216,1)",
        pointRadius: 5,
        pointBackgroundColor: "rgba(2,117,216,1)",
        pointBorderColor: "rgba(255,255,255,0.8)",
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "rgba(2,117,216,1)",
        pointHitRadius: 50,
        pointBorderWidth: 2,
        data: line2_data.length ? line2_data.map(item => item.amount) : [],
      },
    ],
  };

  const dummy_line_data = {
    labels: line_data.length ? line_data.map(item => format(new Date(item.date), 'MMM dd')) : [],
    datasets: [
      {
        fill: true,
        label: "Total Amount(NGN)",
        lineTension: 0.3,
        backgroundColor: "rgba(2,117,216,0.2)",
        borderColor: "rgba(2,117,216,1)",
        pointRadius: 5,
        pointBackgroundColor: "rgba(2,117,216,1)",
        pointBorderColor: "rgba(255,255,255,0.8)",
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "rgba(2,117,216,1)",
        pointHitRadius: 50,
        pointBorderWidth: 2,
        data: line_data.length ? line_data.map(item => item.amount) : [],
      },
    ],
  };

  const dummy_pie_data = {
    labels: pie_data.length ? pie_data.map(item => item.cycle) : [],
    datasets: [
      {
        label: 'Total of Donations in Naira',
        data: pie_data.length ? pie_data.map(item => item.amount) : [],
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  useEffect(() => {
    const donationReportByMonth = () => {
      const records = []
      const allRecord = []

      if (!Array.isArray(data)) return;

      data.forEach(item => {
        if (item?.created_at) {
          const dateObj = new Date(item.created_at)
          if (dateObj.getFullYear() === parseInt(selectedYear)) {
            const amount = parseFloat(item.transaction?.amount || 0)
            records.push({ date: format(dateObj, 'yyyy/MM/dd'), amount })
            allRecord.push({ cycle: item.donation_cycle || 'Other', amount })
          }
        }
      })

      const occurrencesAmount = records.reduce(function (months, record) {
        const monthKey = format(new Date(record.date), 'yyyy/MM')
        if (months[monthKey]) {
          months[monthKey].amount += record.amount
        } else {
          months[monthKey] = {
            date: record.date,
            amount: record.amount
          }
        }
        return months
      }, {});

      const sortedMonths = Object.values(occurrencesAmount).sort((a, b) => (a.date > b.date) ? 1 : -1)

      const occurrencesCycle = allRecord.sort((p1, p2) => (p1.cycle > p2.cycle) ? 1 : (p1.cycle < p2.cycle) ? -1 : 0).reduce(function (allCycles, cycle) {
        if (allCycles.some(function (e) {
          return e.cycle === cycle.cycle
        })) {
          allCycles.filter(function (e) {
            return e.cycle === cycle.cycle
          })[0].amount += cycle.amount
        } else {
          allCycles.push({
            cycle: cycle.cycle,
            amount: cycle.amount
          })
        }
        return allCycles
      }, []);

      setPie_data(occurrencesCycle)
      setBar_data(sortedMonths)
    }

    const donationsThisMonthFunc = () => {
      const today = new Date()
      const currentMonth = format(today, 'yyyy-MM')
      const lastMonth = format(subMonths(today, 1), 'yyyy-MM')

      const records = []
      const lastMonthRecords = []

      if (!Array.isArray(data)) return;

      data.forEach(item => {
        if (item?.created_at) {
          const amount = parseFloat(item.transaction?.amount || 0)
          if (item.created_at.includes(currentMonth)) {
            records.push({ date: format(new Date(item.created_at), 'yyyy/MM/dd'), amount })
          }
          if (item.created_at.includes(lastMonth)) {
            lastMonthRecords.push({ date: format(new Date(item.created_at), 'yyyy/MM/dd'), amount })
          }
        }
      })
      const reduced = records.sort((p1, p2) =>
        (p1.date > p2.date) ? 1 : (p1.date < p2.date) ? -1 : 0).reduce(function (allDates, date) {
          if (allDates.some(function (e) {
            return e.date === date.date
          })) {
            allDates.filter(function (e) {
              return e.date === date.date
            })[0].amount += date.amount
          } else {
            allDates.push({
              date: date.date,
              amount: date.amount
            })
          }
          return allDates
        }, []);

      const reduced2 = lastMonthRecords.sort((p1, p2) =>
        (p1.date > p2.date) ? 1 : (p1.date < p2.date) ? -1 : 0).reduce(function (allDates, date) {
          if (allDates.some(function (e) {
            return e.date === date.date
          })) {
            allDates.filter(function (e) {
              return e.date === date.date
            })[0].amount += date.amount
          } else {
            allDates.push({
              date: date.date,
              amount: date.amount
            })
          }
          return allDates
        }, []);
      setLine_data(reduced)
      setLine2_data(reduced2)
    }

    if (data && selectedYear) {
      donationReportByMonth()
      donationsThisMonthFunc()
    }
  }, [data, selectedYear])

  const totalAmount = React.useMemo(() => {
    if (!data || !Array.isArray(data)) return 0;
    return data.reduce((sum, row) => sum + parseFloat(row?.transaction?.amount || 0), 0);
  }, [data]);

  const handleclick = (obj) => {
    setOpen(true)
    setCurrentData(obj)
  }

  const columns = React.useMemo(
    () => [
      {
        Header: 'S/N',
        id: 'serial',
        Cell: ({ row, state }) => {
          const { pageIndex, pageSize } = state;
          return (pageIndex * pageSize) + row.index + 1;
        }
      },
      {
        Header: 'Date Joined',
        id: 'date_joined',
        accessor: row => row?.user?.created_at ? format(new Date(row.user.created_at), 'MMM dd yyyy') : '-',
      },
      {
        Header: 'Name',
        id: 'donor_name',
        accessor: row => toStartCase(row?.donor_name),
      },
      {
        Header: 'Phone Number',
        id: 'donor_phone_number',
        accessor: row => row?.donor_phone_number || '-',
      },
      {
        Header: 'Amount',
        id: 'amount',
        accessor: row => formatMoney(row?.transaction?.amount),
      },
      {
        Header: 'Donation Date',
        id: 'donation_date',
        accessor: row => row?.created_at ? format(new Date(row.created_at), 'MMM dd yyyy') : '-',
      },
      {
        Header: 'City',
        id: 'city',
        accessor: row => toStartCase(row?.user?.city?.name) || '-',
      },
      {
        Header: 'Level',
        id: 'level',
        accessor: row => toStartCase(row?.user?.category?.name) || '-',
      },
      {
        Header: 'Fundraise',
        id: 'fundraise',
        accessor: row => row?.donation_course?.tagline || '-',
      },
    ],
    []
  )
  return {
    currentData, setCurrentData, open, setOpen, updateMyData, skipPageReset,
    setSearch,
    setSearchLevel, dataReport,
    setSearchStatus, setSearchCycle, selectedYear, setSelectedYear,
    columns, data, pagesize, setData, current, edit, setEdit,
    dummy_data, dummy_line_data, dummy_line2_data, dummy_pie_data, isLoading,
    totalAmount,
    dateJoinedFrom, setDateJoinedFrom, dateJoinedTo, setDateJoinedTo,
    donationDateFrom, setDonationDateFrom, donationDateTo, setDonationDateTo,
  }
}

export default useDonationReport;
